import '../styles/styles.scss'
import '@fortawesome/fontawesome-svg-core/styles.css'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import 'react-loading-skeleton/dist/skeleton.css'
import {
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faCalculator,
  faCheck,
  faCircle,
  faCog,
  faCrown,
  faDragon,
  faEnvelope,
  faEye,
  faLink,
  faMoon,
  faNewspaper,
  faPaperclip,
  faPlus,
  faPodcast,
  faQuestion,
  faRandom,
  faRssSquare,
  faSearch,
  faShirt,
  faSpinner,
  faSun,
  faTimes,
  faTimesCircle,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import ErrorBoundary from './ErrorBoundary'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import React from 'react'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import Router from './Router'
import { SkeletonTheme } from 'react-loading-skeleton'
import configureStore from '../store/configureStore'
import { createFirestoreInstance } from 'redux-firestore'
import { fab } from '@fortawesome/free-brands-svg-icons'
import firebase from 'firebase/compat/app'
import { library } from '@fortawesome/fontawesome-svg-core'
import useDarkMode from 'use-dark-mode'

const { history, persistor, store } = configureStore()

if (firebase.apps.length === 0) {
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  }
  firebase.initializeApp(firebaseConfig)
  firebase.firestore()
}

const App = () => {
  const darkMode = useDarkMode(false)

  library.add(
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faCalculator,
    faCheck,
    faCircle,
    faCog,
    faCrown,
    faDragon,
    faEnvelope,
    faEye,
    faLink,
    faMoon,
    faNewspaper,
    faPaperclip,
    faPlus,
    faPodcast,
    faQuestion,
    faRandom,
    faRssSquare,
    faSearch,
    faShirt,
    faSpinner,
    faSun,
    faTimes,
    faTimesCircle,
    faUser,
    fab
  )

  return (
    <React.StrictMode>
      <ErrorBoundary>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ReactReduxFirebaseProvider
              config={{
                preserveOnLogin: { profile: true },
                useFirestoreForProfile: true,
                userProfile: 'users',
              }}
              createFirestoreInstance={createFirestoreInstance}
              dispatch={store.dispatch}
              firebase={firebase}
            >
              <SkeletonTheme
                baseColor={darkMode.value ? '#888' : null}
                highlightColor={darkMode.value ? '#adb5bd' : null}
              >
                <Router history={history} />
              </SkeletonTheme>
            </ReactReduxFirebaseProvider>
          </PersistGate>
        </Provider>
      </ErrorBoundary>
    </React.StrictMode>
  )
}

export default App
